<div class="center">
  <div class="not-found">Not Found!</div>
  <button (click)="back()">Go Back</button>
</div>
